export default "__VITE_ASSET__weqmPMKi__"